import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { FOLLOW_UP_BEATS, FOLLOW_UP_TIMELINE } from './constants';
import { ReminderMockup } from './ProductMockups';

const FollowUps = () => {
	return (
		<Box
			id="follow-ups"
			component="section"
			sx={{
				py: { xs: 7, md: 10 },
				bgcolor: 'background.paper',
				borderTop: '1px solid',
				borderBottom: '1px solid',
				borderColor: 'divider',
				scrollMarginTop: { xs: 72, md: 80 },
			}}
		>
			<Container maxWidth="lg">
				<Box sx={{ textAlign: 'center', mb: { xs: 5, md: 6 } }}>
					<Typography
						variant="overline"
						color="warning.main"
						sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
					>
						Automated follow-ups
					</Typography>
					<Typography
						variant="h4"
						component="h2"
						sx={{ mt: 1, fontWeight: 700 }}
					>
						Send the bid. Stop chasing it.
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						sx={{ mt: 2, maxWidth: 640, mx: 'auto', lineHeight: 1.8 }}
					>
						Most subs lose work in the gap between “I sent it” and “did you see
						it?” Bidzbase emails the customer for you — on pending proposals
						and unpaid invoices — until they answer.
					</Typography>
				</Box>

				<Grid container spacing={4} alignItems="stretch" sx={{ mb: { xs: 5, md: 6 } }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<Stack spacing={2.5}>
							{FOLLOW_UP_TIMELINE.map((item) => (
								<Stack
									key={item.title}
									direction="row"
									spacing={2}
									alignItems="flex-start"
								>
									<Typography
										variant="caption"
										sx={{
											fontWeight: 800,
											color: 'warning.main',
											minWidth: 88,
											pt: 0.35,
											letterSpacing: '0.04em',
											textTransform: 'uppercase',
										}}
									>
										{item.when}
									</Typography>
									<Box>
										<Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
											{item.title}
										</Typography>
										<Typography
											variant="body2"
											color="text.secondary"
											sx={{ mt: 0.5, lineHeight: 1.7 }}
										>
											{item.detail}
										</Typography>
									</Box>
								</Stack>
							))}
						</Stack>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<ReminderMockup />
					</Grid>
				</Grid>

				<Grid container spacing={2}>
					{FOLLOW_UP_BEATS.map((item) => (
						<Grid key={item.pain} size={{ xs: 12, sm: 6 }}>
							<Paper
								elevation={0}
								sx={{
									p: 2.5,
									height: '100%',
									borderRadius: 3,
									border: '1px solid',
									borderColor: 'divider',
								}}
							>
								<Typography
									variant="body2"
									color="text.secondary"
									sx={{ textDecoration: 'line-through', mb: 0.75 }}
								>
									{item.pain}
								</Typography>
								<Typography variant="body1" sx={{ fontWeight: 600, lineHeight: 1.6 }}>
									{item.win}
								</Typography>
							</Paper>
						</Grid>
					))}
				</Grid>
			</Container>
		</Box>
	);
};

export default FollowUps;
